/**
 * Inicialización de la clase TransactionInfoModel, modelo de la información del dispositivo donde es cargada la aplicación
 * *Set TransactionInfoModel class, model of the device information where the applicaction is being run*
 *
 * @access public
 * @type {class}
 */
export class TransactionInfoModel {
  /**
   *
   * @type {string} transaction_code
   */
  transaction_code?: string;

  /**
   *
   * @type {string} transaction_type
   */
  transaction_type: string;

  /**
   * Constructor de la clase
   * *Class Contstructor.*
   *
   * @var {string}   transaction_code  Sets variable as empty
   * @var {string}   transaction_type Sets variable as empty
   *
   */
  constructor() {
    this.transaction_code = '';
    this.transaction_type = '';
  }
}
